.google-logo {
    height: 25px;
    margin-bottom: 3px;
}